module.exports = [360, 375, 414, 640, 720, 750, 768, 828, 1024, 1080, 1125, 1242, 1280, 1536, 1920, 2000];
